import "./PaymentStatusView.css"
import {useEffect, useMemo, useState} from "react";
import Footer from "../../../component/footer/Footer";
import Navbar from "../../../component/navbar/Navbar";
import {IconAlertCircle, IconCircleCheck, IconCircleX, IconReceiptRefund} from "@tabler/icons-react";
import fetchWithRetry from "../../../util/request";
import {useNavigate, useParams} from "react-router-dom";
import {PaymentRecord} from "../../account/payments/PaymentList";
import {Trans, useTranslation} from "react-i18next";

export default function PaymentStatusView() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const query = useMemo(() => new URLSearchParams(window.location.search), []);
    let {paywall} = useParams();

    const [payment, setPayment] =
        useState<PaymentRecord | null | undefined>(undefined)

    useEffect(() => {
        const paymentId = query.get("id");

        if (paymentId === null) {
            setPayment(null);
            return;
        }

        setPayment({"uuid":"7a1f4e60-fca2-499d-b482-36cff9f960e5","date":1733317882,"currency":"CZK","state":"PENDING","total":10000,"sms_code":"UjL2wPXj","item_count":1,"currency_multiplied":100,"sms_info":{"number":"90733","price":"99 Kč"}} as PaymentRecord)

        return fetchWithRetry(async res => {
            if (res.status === 404) {
                setPayment(null);
                navigate("/store")
                return true;
            }
            if (!res.ok) return false;
            return res.json().then(body => {
                const payment = body as PaymentRecord;
                setPayment(payment);
                return payment.state !== "PENDING";
            })
        }, `${process.env.REACT_APP_API_BASE}/store/payment/${paywall ? `${paywall}/` : ""}${paymentId}/state`, {}, 1500);
    }, [query, paywall, setPayment, navigate])

    const state = payment?.state;

    let content;

    if (state === "COMPLETED") {
        content = <div className={"status green"}>
            <IconCircleCheck className={"icon"}/>
            <h2>{t("paymentStatus.thankYou")}</h2>
            <p className={"description"}>{t("paymentStatus.deliveredIn")}</p>
        </div>
    } else if (state === "PENDING") {
        content = <div className={"status"}>
            <div className={"loader icon"}/>
            <h2>{payment?.sms_code ? t("paymentStatus.waitingForSms") : t("paymentStatus.processing")}</h2>
            {!payment?.sms_code ? null : <>
                <p className={"sms-info"}>
                    <Trans i18nKey={"paymentStatus.smsInstructions"} values={{
                        code: payment?.sms_code,
                        number: payment?.sms_info?.number,
                        price: payment?.sms_info?.price
                    }} components={{
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        link: <a href={`sms:${payment?.sms_info?.number}?&body=${encodeURI(`PTC ${payment?.sms_code}`)}`}/>,
                        b: <span/>,
                        b2: <span/>
                    }}/>
                </p>
                <p className={"sms-info-provider"}>
                    {t("paymentStatus.smsProviderInfo")}
                </p>
            </>}
        </div>
    } else if (state === "CANCELED") {
        content = <div className={"status red"}>
            <IconCircleX className={"icon"}/>
            <h2>{t("paymentStatus.canceled")}</h2>
        </div>
    } else if (state === "REFUNDED") {
        content = <div className={"status red"}>
            <IconReceiptRefund className={"icon"}/>
            <h2>{t("paymentStatus.refunded")}</h2>
        </div>
    } else if (state === null) {
        content = <div className={"status red"}>
            <IconAlertCircle className={"icon"}/>
            <h2>{t("paymentStatus.notFound")}</h2>
        </div>
    } else {
        content = <div className={"loader big center margin"}/>;
    }

    return <div className={"payment-status-view"}>
        <Navbar/>
        {content}
        <Footer/>
    </div>
}